// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/bop-go/conto-economico?societaId=1&modo=anni&anno=2026&mese_da=1&mese_a=8',
    requestBody: null,
    response: '{"success":true,"stato":"OK","data":{"modo":"anni","periodo":{"descrizione":"gen–ago 2024–2026"},"colonne":[{"chiave":"2024","etichetta":"2024","da":"2024-01-01","a":"2024-08-31"}],"voci":[{"chiave":"RI","livello":1,"codice":"RI","descrizione":"Ricavi","valori":{"2024":2377045},"totale":2377045,"figli":[]}],"ricavi":{"2024":2377045},"costi":{"2024":-2311520},"totali":{"2024":65525},"periodo_aperto":true}}'
  },
  {
    method: 'GET',
    endpoint: '/api/bop-go/conto-economico/export/excel?societaId=1&modo=anni&anno=2026&mese_da=1&mese_a=8&livello=2',
    requestBody: null,
    response: 'file xlsx'
  },
  {
    method: 'GET',
    endpoint: '/api/bop-go/conto-economico/export/pdf?societaId=1&modo=anni&anno=2026&mese_da=1&mese_a=8&livello=2',
    requestBody: null,
    response: 'file pdf'
  },
  {
    method: 'GET',
    endpoint: '/api/bop-go/conto-economico/registrazioni?societaId=1&conto=CO010614&da_data=2026-01-01&a_data=2026-08-31&criterio=competenze',
    requestBody: null,
    response: '{"success":true,"stato":"OK","data":{"totale":"number","importo":"string","has_more":"boolean","data":[{"data_competenza":"string","causale":"string","descrizione":"string","dare":"string","avere":"string","importo":"string","tipo_competenza":"string","competenza_dal":"string","competenza_al":"string"}]}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
